<div class="w-full grid grid-cols-12 gap-4">
  <div class="col-start-3 col-span-8 flex justify-center">
    <p-paginator
      [first]="first() ?? 0"
      [rows]="rows() ?? 10"
      [totalRecords]="totalRecords()"
      (onPageChange)="onPageChange($event)"
    >
      <ng-template pTemplate="firstpagelinkicon">
        <span class="material-symbols-outlined">first_page</span>
      </ng-template>
      <ng-template pTemplate="previouspagelinkicon">
        <span class="material-symbols-outlined">chevron_left</span>
      </ng-template>
      <ng-template pTemplate="lastpagelinkicon">
        <span class="material-symbols-outlined">last_page</span>
      </ng-template>
      <ng-template pTemplate="nextpagelinkicon">
        <span class="material-symbols-outlined">chevron_right</span>
      </ng-template>
    </p-paginator>
  </div>
  <div class="col-span-2 flex flex-col justify-center items-end pr-4">
    <p-select
      class="w-20"
      appendTo="body"
      [options]="rowsPerPageOptions()"
      [(ngModel)]="selectedRowsPerPage"
      (ngModelChange)="onRowsChange($event)"
    />
  </div>
</div>
